var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlayStore = function SvgPlayStore(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 14 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#32BBFF",
    d: "M10.8 5.49 1.69.19c-.3-.2-.65-.23-.94-.13L8.39 8l2.42-2.51Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#32BBFF",
    d: "M.74.06.57.13C.24.32 0 .67 0 1.13v13.74a1.12 1.12 0 0 0 .73 1.07L8.4 8z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#32BBFF",
    d: "M8.39 8 .73 15.94c.3.1.65.08.95-.13a6316 6316 0 0 1 9.13-5.3z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#2C9FD9",
    d: "M0 8v6.87a1.12 1.12 0 0 0 .73 1.07L8.4 8z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#29CC5E",
    d: "M1.68.19A1.05 1.05 0 0 0 .58.13l7.69 7.99 2.54-2.63z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#D93F21",
    d: "m8.27 7.88-7.7 7.99c.33.18.75.19 1.11-.06a6316 6316 0 0 1 9.13-5.3z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFD500",
    d: "M14 8c0-.38-.19-.77-.55-.98l-2.8-1.62L8.16 8l2.5 2.6 2.8-1.62c.36-.22.55-.6.55-.98Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#FA0",
    d: "M13.45 8.98c.36-.22.55-.6.55-.98H8.15l2.5 2.6z"
  })));
};
export default SvgPlayStore;